import React from 'react'
import { useRouter } from 'next/router'
import { THEME, formatDate, authorLink } from 'utils'
import SharingLinks from 'components/SharingLinks'

const StoryMeta = ({ story, placement = 'top', video }) => {
  const router = useRouter()
  const handleClick = () => {
    if (story.author.is_active) {
      return router.push(authorLink(story.author).href, authorLink(story.author).as)
    }
  }
  return (
    <>
      <div className={`storyMeta storyMeta--${placement} ${video ? 'storyMeta--video' : ''}`}>
        <div className='storyMeta__left'>
          <a
            className={`storyMeta__author ${story.author.is_active ? 'storyMeta__author--active' : ''}`}
            onClick={handleClick}
          >
            {story.author.avatar && <img className='avatar' alt={story.author.name} src={story.author.avatar} />}
            <div className='byline'>
              <span className='authorName'>{story.author.name}</span>
              <span className='timestamp'>{formatDate(story.date, 'M/dd/yyyy h:mm a')}</span>
            </div>
          </a>
        </div>
        <div className='storyMeta__right'>
          <SharingLinks story={story} location={placement === 'top' ? 'storyHeader' : 'storyFooter'} />
        </div>
      </div>
      <style jsx>{`
        .storyMeta {
          display: flex;
          flex-direction: column;
          align-items: left;
          justify-content: space-between;
          padding: 8px 18px;
        }
        .storyMeta--top {
          border-bottom: 1px solid ${THEME.COLORS.LIGHTGRAY};
        }
        .storyMeta--bottom {
          border-top: 1px solid ${THEME.COLORS.LIGHTGRAY};
        }
        .storyMeta__author {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
        }
        .storyMeta__author--active {
          cursor: pointer;
        }
        .storyMeta__author--active:hover .authorName {
          text-decoration: underline;
        }
        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .byline span {
          display: block;
        }
        .authorName {
          color: #333;
          font-size: 12px;
          font-weight: 500;
          line-height: 15px;
        }
        .timestamp {
          color: ${THEME.COLORS.GRAY};
          font-size: 12px;
          font-style: italic;
          letter-spacing: 0.1px;
          line-height: 15px;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .avatar {
            width: 40px;
            height: 40px;
            margin-right: 12px;
          }
          .authorName,
          .timestamp {
            font-size: 14px;
            line-height: 18px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          .storyMeta {
            flex-direction: row;
            align-items: center;
            // padding: 20px 0;
          }
          .storyMeta__left {
            margin-bottom: 0;
          }
        }
      `}</style>
    </>
  )
}

export default StoryMeta
